import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export function LanguageSync() {
  const { i18n } = useTranslation();

  useEffect(() => {
    try {
      const saved = localStorage.getItem('app-language');
      if (saved && ['es', 'en'].includes(saved) && i18n.language !== saved) {
        i18n.changeLanguage(saved);
      }
    } catch {
      // ignore localStorage errors
    }
  }, [i18n]);

  return null;
}